<script lang="ts">
	import type { InventoryLocations$result } from '$houdini'
	import type { i18n } from 'types/common'

	import { Table, Td } from '@isoftdata/svelte-table'
	import { graphql } from '$houdini'
	import Icon from '@isoftdata/svelte-icon'
	import { getContext } from 'svelte'

	type InventoryLocation = InventoryLocations$result['inventory']['locations'][0]

	interface Props {
		inventoryId: number
	}

	let { inventoryId }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')

	const locationsQuery = graphql(`
		query InventoryLocations($inventoryId: UInt!) {
			inventory(id: $inventoryId) {
				locations {
					location {
						name
					}
					quantity
				}
			}
		}
	`)

	async function loadLocations(inventoryId: number): Promise<Array<InventoryLocation>> {
		return inventoryId
			? ((await locationsQuery.fetch({ variables: { inventoryId }, policy: 'CacheOrNetwork' }))?.data?.inventory
					?.locations ?? [])
			: []
	}

	const locations = $derived(loadLocations(inventoryId))
</script>

{#await locations}
	<Icon
		icon="spinner"
		class="fa-xl fa-spin"
	/>
{:then loadedLocations}
	{@const flatInventoryLocations = loadedLocations.map(location => {
		return {
			name: location.location?.name ?? translate('partSearch.unknown', 'Unknown'),
			quantity: location.quantity,
		}
	})}
	<Table
		responsive
		rows={flatInventoryLocations}
		columns={[
			{ property: 'name', name: translate('common:name', 'Name') },
			{ property: 'quantity', name: translate('common:quantity', 'Quantity') },
		]}
	>
		{#snippet children({ row: inventoryLocation })}
			{@const { name, quantity } = inventoryLocation}
			<tr>
				<Td property="name">{name}</Td>
				<Td property="quantity">{parseFloat(quantity) ? parseFloat(quantity).toString() : '0'}</Td>
			</tr>
		{/snippet}
	</Table>
{:catch error}
	<p>{translate('partSearch.errorLoadingPartLocations', 'Error loading part locations.')}</p>
{/await}
